<template>
  <div 
    class="premium-wrapper"
    :class="{ 'premium-active-container': premium && premium.isActive }"
  >
    <PremiumSkeleton v-if="isLoading" />

    <PremiumActive
      v-else-if="premium && premium.isActive"
      :premium="premium"
      @renew="emit('clickPremium')"
    />

    <PremiumStub v-else @subscribe="emit('clickPremium')" />
  </div>
</template>


<script setup>
  import { ref, onMounted, defineEmits } from "vue";
  import PremiumService from "../../api/PremiumService";
  
  import PremiumStub from "./PremiumStub.vue";
  import PremiumActive from "./PremiumActive.vue";
  import PremiumSkeleton from "./PremiumSkeleton.vue";
  
  const emit = defineEmits(["clickPremium"]);
  
  const premium = ref(null);
  const isLoading = ref(true);
  
  console.log("📦 ProfilePremium.vue: инициализация компонента");
  
  onMounted(async () => {
    console.log("🚀 onMounted — начинаем загрузку подписки...");
    try {
      premium.value = await PremiumService.fetchMySubscription();
      console.log("✅ Подписка загружена:", premium.value);
    } catch (e) {
      console.error("❌ Ошибка при загрузке подписки:", e);
      premium.value = null;
    } finally {
      isLoading.value = false;
      console.log("🔚 Загрузка завершена, isLoading =", isLoading.value);
    }
  });
  </script>
  

<style scoped>

.premium-wrapper {
  padding: 24px;
  transition: padding 0.2s ease;
}

.premium-active-container {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.premium-active-container .premium-card {
  transform: translateX(-250px); /* ← регулируй смещение тут */
}

</style>